import { Divider, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { useNavigate } from "react-router-dom";
import { getPermissions } from "../../../commonFunctions/PermissionManger";
import {
  callAPI,
  IRoleMain,
  MasterPages,
  Method
} from "../../../commonFunctions/CommonFunctions";
import { Header } from "../../../Components/Header/Header";
import WSImageView from "../../../Components/Image/WSImageView";
import ConfirmationPopup from "../../../Components/Confirmation/Confirmation";
import { resetDataComponent } from "../../../StateManagement/actions";
import { useDispatch } from "react-redux";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";

export const TopBrandList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const dispatch = useDispatch();
  const { showMessage } = useSnackbar();

  const source = {
    url: "TopBrand/search",
    page: 1,
    pageSize: 10,
    filter: [],
    sort: []
  };

  /**
   * Edit function
   * @param action
   * @param row
   */
  const handleAction = (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/brand/${row?.id}`);
    }
    if (action === "Delete") {
      setSelectedId(row.id); // Set the ID of the row to be deleted
      setPopupOpen(true);
    }
  };
  const columns: IColumns[] = [
    {
      header: "Logo",
      fieldName: "logoUrl",
      tooltip: true,
      type: "img"
    },
    {
      header: "Web Url",
      fieldName: "websiteUrl",
      type: "default"
    },
    {
      header: "Created On",
      fieldName: "createdAt",
      type: "date"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: [edit ? "Edit" : undefined, "Delete"],
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/brand/create");
  };
  const handleDelete = () => {
    dispatch(resetDataComponent("brandGrid"));
    showMessage("Brand deleted successfully!", "success");
  };
  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Header
        type="simple"
        isDivider={true}
        title="Top Brands"
        id={"brandHeader"}
        headerSx={{ marginTop: 0 }}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="brandGrid"
            title="Brands"
            columns={columns}
            source={source}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            gridHeaderSx={{
              backgroundColor: "whitesmoke",
              border: "1px solid whitesmoke"
            }}
          />
          {selectedId !== null && (
            <ConfirmationPopup
              apiUrl={"TopBrand/delete"}
              id={selectedId}
              confirmMessage="Are you sure you want to delete this item?"
              open={isPopupOpen}
              onClose={() => setPopupOpen(false)}
              onConfirm={handleDelete}
            />
          )}
        </Grid>
      </Grid>
    </>
  );
});
